/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('building.filter', function (el) {
        util.delegate(el, 'change', 'select', function () {
            el.submit();
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
